import React, { Component, useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';

import moment from 'moment';

import DatePicker from 'react-datepicker';

const DateAndTimePicker = ({ existingDate, dateParse, title, action, wFull, titleColor, className, name, handleDate }) => {
  const [startDate, setStartDate] = useState();

  useEffect(() => {
    let date;
    const isTimestamp = !Number.isNaN(Number(existingDate));

    if (dateParse) {
      date = new Date(Date.parse(existingDate));
    } else {
      if (isTimestamp) date = new Date(moment(parseInt(existingDate)));
      else date = new Date(moment(existingDate));
    }
    if (existingDate) setStartDate(date);
  }, [existingDate]);

  const handleChange = (date) => {
    setStartDate(date);
    handleDate(name, moment(date).format());
  };

  return (
    <div className={`py-4 mb-4 ${className} ${wFull ? 'w-full' : 'w-1/5'}`}>
      <div>
        <span className={`font-americaMonoRegular text-xs uppercase text-${titleColor}`}>{title}</span>
      </div>
      <DatePicker
        selected={startDate}
        onChange={handleChange}
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={5}
        dateFormat="MMMM d, yyyy h:mm aa"
        timeCaption="time"
        className={`${(action === 'display' || action === 'delete') && 'bg-grey'} px-6 py-2 outline-none rounded-full mt-2 w-full mr-4 font-americaMonoBold text-sm text-center`}
        withPortal
        disabled={action === 'display' || action === 'delete'}
        fixedHeight
      />
    </div>
  );
};

DateAndTimePicker.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  existingDate: PropTypes.string,
  handleDate: PropTypes.func.isRequired,
  wFull: PropTypes.bool,
  dateParse: PropTypes.bool,
  titleColor: PropTypes.string,
  className: PropTypes.string,
  timezone: PropTypes.string,
};

DateAndTimePicker.defaultProps = {
  existingDate: '',
  wFull: false,
  dateParse: false,
  titleColor: 'white',
  className: null,
  timezone: null,
};

export default DateAndTimePicker;
